<template>
  <div
    :class="[
      'w-50 h-15.5 overflow-hidden bg-white rounded-lg outline outline-border-default transition-colors',
      {
        'hover:outline-secondary': isReady,
      },
    ]"
  >
    <ClientOnly>
      <AtomTransition timing="fast">
        <div
          v-show="isReady"
          ref="widget"
          :key="computedLocale"
          class="trustpilot-widget"
          :data-locale="computedLocale"
          data-template-id="54197383fd9dceac42a68694"
          data-businessunit-id="5c8971694a3457000155554d"
          data-style-width="200px"
          data-style-height="62px"
          data-style-size="XS"
          data-token="e47a2b04-a907-4768-9564-5599cea69a50"
          data-headline="star"
          data-support-text="review-number"
          data-use-category-name="false"
          data-use-category-icon="false"
          data-text-color="dark"
          data-background="light"
          data-tags="score-only"
        >
          <a
            href="https://www.trustpilot.com/review/rvezy.com"
            target="_blank"
            rel="noopener"
          >Trustpilot</a>
        </div>
      </AtomTransition>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n()

const widget = useTemplateRef('widget')
const isReady = ref(false)

const computedLocale = computed(() => locale.value === 'fr' ? 'fr-FR' : 'en-US')

/**
 * The bootstrap script only scans the DOM once when it loads, so widgets
 * rendered after that (ClientOnly, client side navigation) must be loaded
 * explicitly. Runs whenever either the element or the script becomes ready.
 */
function loadWidget() {
  if (widget.value && window.Trustpilot) {
    window.Trustpilot.loadFromElement(widget.value)
  }
}

useHead({
  script: [
    {
      src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
      async: true,
      onload: loadWidget,
    },
  ],
})

watch(widget, () => {
  isReady.value = false
  loadWidget()
})

/**
 * The widget iframe posts a `resize-height` message once its content has
 * rendered, which is the earliest point it can be shown without flashing.
 */
useEventListener('message', (event) => {
  if (event.origin !== 'https://widget.trustpilot.com') {
    return
  }

  if (event.source !== widget.value?.querySelector('iframe')?.contentWindow) {
    return
  }

  try {
    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data

    if (data?.command === 'resize-height') {
      isReady.value = true
    }
  }
  catch {
    // Ignore messages that are not JSON
  }
})
</script>
